var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 2.667H12V2c0-.367-.3-.667-.667-.667-.366 0-.666.3-.666.667v.667H5.333V2c0-.367-.3-.667-.666-.667C4.3 1.333 4 1.633 4 2v.667h-.667c-.74 0-1.326.6-1.326 1.333L2 13.333c0 .734.593 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V4c0-.733-.6-1.333-1.333-1.333zm0 10c0 .366-.3.666-.667.666H4a.669.669 0 0 1-.667-.666V6h9.334v6.667zm-8-5.334H6v1.334H4.667V7.333zm2.666 0h1.334v1.334H7.333V7.333zm2.667 0h1.333v1.334H10V7.333z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheets);
export default __webpack_public_path__ + "static/media/timesheets.32de112f6e7102ada839002d890bd004.svg";
export { ForwardRef as ReactComponent };